import {SET_APP_OPTIONS} from '../actions/options.action.js';
import {mixins} from 'ereader-core/dist/utils.mixins.js';
import {default_state} from './index.js';

export function app(state = default_state.app, action={}){
    if (action.type != SET_APP_OPTIONS) return state;

    return mixins.Options.setOptions(state, action.options);
}


// WEBPACK FOOTER //
// ./src/reducers/app.reducer.js